import { Header } from "../../common/header";
import { Footer } from "../main-page/footer";
import { Spinner } from "../../common/spinner";
import { useRouteNavigation } from "../../../lib/common/routes";
import { useEmailVerificationFirebaseLink } from "../../../services/firebase_email_actions";
import { useEffect } from "react";

const getValidatedOobCode = () => {
    const params = new URLSearchParams(window.location.search);
    const oobCodes = params.getAll("oobCode");

    if (oobCodes.length !== 1) return null;

    const oobCode = oobCodes[0]?.trim();
    if (!oobCode) return null;

    return oobCode;
};

export const AuthFireBaseVerifyEmail = () => {
    const { navigateToRoute } = useRouteNavigation();
    const { status, error, verifyUserEmailFB } = useEmailVerificationFirebaseLink();

    const oobCode = getValidatedOobCode();

    const refreshAfterVerificationClickHandler = () => {
        navigateToRoute("home");
    };

    useEffect(() => {
        if (!oobCode) {
            return;
        }

        verifyUserEmailFB(oobCode);
    }, []);

    return (
        <>
            <Header title="Email Verification" />

            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-5">
                        <div className="card shadow-sm border p-4 text-center rounded-4">
                            {oobCode && status === "firebaseVerifyingEmail" && (
                                <>
                                    <Spinner spinnerColor="text-primary" />
                                    <p className="text-muted mt-2">Verifying your email…</p>
                                </>
                            )}

                            {!oobCode && (
                                <>
                                    <i className="fa-solid fa-circle-exclamation text-primary fs-2 mb-2"></i>
                                    <p className="fw-bold text-primary">This verification link is invalid or incomplete.</p>
                                </>
                            )}

                            {status === "done" && (
                                <>
                                    <i className="fa-solid fa-circle-check text-primary fs-2 mb-2"></i>
                                    <h5 className="fw-bold text-primary">Email verified successfully</h5>
                                    <p className="text-muted small mt-2">You can now safely close this tab or continue to the app.</p>
                                    <button className="btn btn-primary fw-bold w-100 mt-3" onClick={refreshAfterVerificationClickHandler}>
                                        Go to Home
                                    </button>
                                </>
                            )}

                            {status === "error" && (
                                <>
                                    <i className="fa-solid fa-circle-exclamation text-primary fs-2 mb-2"></i>
                                    <p className="fw-bold text-primary">{error}</p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};
